import React from 'react';

function isLastIndex(data) {
  return data?.elements ? data?.elements?.length : 0;
}

function CartItemRemoveMessageAttributes({ data }) {
  return (
    <span className="!font-semibold !tracking-[0.28px]">
      {' ('}
      {data?.elements?.map((attr, index) => (
        <span key={attr.attribute_id}>
          {attr?.attribute_name?.en}
          {attr?.attribute_name?.en ? ':' : ''}{' '}
          <span key={attr.attribute_id} className="capitalize">
            {attr?.attribute_value?.en}
          </span>
          {index !== isLastIndex(data) - 1 ? ' , ' : ''}
        </span>
      ))}
      {') '}
    </span>
  );
}

export default CartItemRemoveMessageAttributes;
